<!-- 猜你想要 -->
<template>
  <div class="guess-comp" v-if="dataList && dataList.length">
    <ul>
      <li v-for="(item, index) in dataList" :key="index">
        <span class="li-title">{{ index + 1 }}：</span>
        <span class="li-content">{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GuessComp',
  props: ['option'],
  created() {
    this.dataList = this.option.content || []
  },
  data() {
    return {
      dataList: null
    }
  }
}
</script>

  <style lang="scss" scoped>
.guess-comp {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  ul {
    width: 100%;
    li {
      margin-bottom: 5px;
      line-height: 20px;
      text-align: left;
    }
  }
}
</style>
